import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import CircularProgress from "@mui/material/CircularProgress";
import "./FestivalviewMenuIcon.scss";
import SubMenuThreeDotIcon from "../../../../../components/icons/SubMenuThreeDotIcon";
import toast from "react-hot-toast";
import { TemplatesApi } from "../../../../../utils/api/Templates";
import CancelModal from "../list/CancelModal";
import DeleteModal from "../list/DeleteModal";
import { Modal } from "@mui/material";
import { clientRoutes } from "../../../../../utils/routes";
import { useNavigate, useSearchParams } from "react-router-dom";
import { PropertyApi } from "../../../../../utils/api/Property";

const FestivalviewMenuIcon = ({
  postId,
  onViewDetails,
  onEdit,
  onConfirmPost,
  onPostNow,
  onCancel,
  onDelete,
  onPreview,
  previewImageUrl,
  onUpdated,
}: {
  postId: string;
  onViewDetails?: () => void;
  onEdit?: () => void;
  onConfirmPost?: () => void;
  onPostNow?: () => void;
  onPreview?: () => void;
  onCancel?: () => void;
  onDelete?: () => void;
  previewImageUrl?: string;
  onUpdated?: () => void;
}) => {
  const [isLoading, setIsLoading] = React.useState(false);
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [isCancelModalOpen, setIsCancelModalOpen] = React.useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = React.useState(false);
  const [modalOpen, setModalOpen] = React.useState(false);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleOpenCancelModal = () => setIsCancelModalOpen(true);
  const handleCloseCancelModal = () => setIsCancelModalOpen(false);

  const handleOpenDeleteModal = () => setIsDeleteModalOpen(true);
  const handleCloseDeleteModal = () => setIsDeleteModalOpen(false);

  const handleCancelPost = async () => {
    try {
      setModalOpen(true);
      setIsLoading(true);
      await PropertyApi.updateFestivalPost(
        {
          post_status: "cancelled",
          schedule_datetime: null,
        },
        postId
      );
      toast.success("Post cancelled successfully");
      onUpdated?.();
    } catch (error) {
      console.error("Failed to cancel post:", error);
      toast.error("Failed to cancel post");
    } finally {
      setIsLoading(false);
      setModalOpen(false);
      handleCloseCancelModal();
      handleClose();
    }
  };

  const handleDeletePost = async () => {
    try {
      setModalOpen(true);
      setIsLoading(true);
      await PropertyApi.updateFestivalPost({ post_status: "trash" }, postId);
      toast.success("Post deleted successfully");
      const subscriptionType = searchParams.get("subscription_type");
      const backUrl = subscriptionType
        ? `${clientRoutes.FestivalPostList}?subscription_type=${subscriptionType}`
        : clientRoutes.FestivalPostList;

      navigate(backUrl);
      onUpdated?.();
    } catch (error) {
      console.error("Failed to delete post:", error);
      toast.error("Failed to move post to Trash");
    } finally {
      setIsLoading(false);
      setModalOpen(false);
      handleCloseDeleteModal();
      handleClose();
    }
  };

  const downloadImagePreview = (imageUrl: string) => {
    if (!imageUrl) return;

    const relativePath = imageUrl.replace(/^.*\/design-tool\/images\//, "");

    const downloadUrl = `https://designtoolapi.share.zrok.io/api/design-tool/download-image?asset_path=${relativePath}`;

    const link = document.createElement("a");
    link.href = downloadUrl;
    link.setAttribute(
      "download",
      relativePath.split("/").pop() || "preview.jpg"
    );
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <>
      <div
        className="festival-menu-icon"
        onClick={handleClick}
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
      >
        {isLoading ? (
          <CircularProgress
            className="circular-progress-action-icon"
            style={{ width: 15, height: 15 }}
          />
        ) : (
          <SubMenuThreeDotIcon />
        )}
      </div>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          "aria-labelledby": "basic-button",
        }}
        className="custom-action-menu"
        PaperProps={{
          elevation: 3,
          sx: {
            borderRadius: "10px",
            mt: 1,
            width: 200,
            boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.1)",
          },
        }}
      >
        <MenuItem
          onClick={() => {
            onPreview?.();
            handleClose();
          }}
        >
          Preview
        </MenuItem>
        <MenuItem
          onClick={() => {
            if (previewImageUrl) {
              downloadImagePreview(previewImageUrl);
            }
            handleClose();
          }}
        >
          Download Preview
        </MenuItem>
        {/* <MenuItem
          onClick={() => {
            handleClose();
          }}
        >
          Reschedule
        </MenuItem> */}
        <MenuItem
          onClick={() => {
            handleClose();
            handleOpenCancelModal();
          }}
        >
          Cancel
        </MenuItem>
        <MenuItem
          onClick={() => {
            handleClose();
            handleOpenDeleteModal();
          }}
        >
          Delete
        </MenuItem>
      </Menu>

      <CancelModal
        isOpen={isCancelModalOpen}
        onCancel={handleCloseCancelModal}
        onConfirm={handleCancelPost}
      />

      <DeleteModal
        isOpen={isDeleteModalOpen}
        onCancel={handleCloseDeleteModal}
        onConfirm={handleDeletePost}
      />

      <Modal
        open={modalOpen}
        onClose={(event, reason) => {
          if (reason !== "backdropClick") {
            setModalOpen(false);
          }
        }}
        aria-labelledby="processing-modal"
        className="add-property-modal styled-modal"
        disableEscapeKeyDown
      >
        <div className="modal-center-wrapper">
          <div className="loading-content-wrapper">
            <div className="loading-container">
              <div className="spinner" />
              <p className="loading-text">
                Processing your request
                <span className="desktop-break">
                  <br />
                </span>
                Please wait...
              </p>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default FestivalviewMenuIcon;
